import { useV2ListTeamsForAccountQuery } from "@generated";

interface Team {
  id: string;
  name: string;
}

const useListTeamsForAccount = () => {
  let customError: string | null = null; // Declare customError
  const {
    data,
    error,
    isLoading: teamsLoading,
  } = useV2ListTeamsForAccountQuery({});
  let teams: Team[] = [];
  if (data?.data) {
    try {
      teams = data.data.map((team) => {
        if (!team.id) {
          throw new Error("Missing team.id");
        }
        if (!team.attributes.name) {
          throw new Error("Missing team.attributes.name");
        }
        return {
          id: team.id,
          name: team.attributes.name,
        };
      });
    } catch (e) {
      customError = "An unknown error occurred";
    }
  }
  return { teams, teamsLoading, error: error ?? customError };
};
export default useListTeamsForAccount;
